import { useFormContext } from 'react-hook-form';
import { RoutingRulesFormFields } from '../../../../utils';
import {
    ItemsAndConditionsFormFields,
    ItemsAndConditionsSchemaFormValues,
    RoutingRuleFormValues,
} from '../../../../../../schemas';

export const useSelectedGroupsAndReservationsCount = (): number => {
    const { watch } = useFormContext<RoutingRuleFormValues>();

    const groupsAndReservations = watch(
        RoutingRulesFormFields.groupsAndReservations()
    ) as ItemsAndConditionsSchemaFormValues[ItemsAndConditionsFormFields.GroupsAndReservations];
    const { reservationIds, reservationGroupIds } = groupsAndReservations || {};

    return (reservationIds?.length || 0) + (reservationGroupIds?.length || 0);
};
